<template>
  <v-container id="user-profile-view" fluid tag="section">
    <template>
      <v-card>
        <v-card-title>
          TTB
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="data"
          :options.sync="options"
          :server-items-length="totalData"
        >
          <template v-slot:item.actions="{ item }">
            <div class="d-md-none my-5"></div>
            <v-icon @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "TTBTidakAdaUkuranView",
  data() {
    return {
      id: "",
      search: "",
      totalData: 0,
      data: [],
      loading: false,
      options: {},
      headers: [
        { text: "Kode TTB", value: "kodettb" },
        { text: "No TTB", value: "nottb" },
        { text: "Tgl", value: "tgl" },
        { text: "Pengirm", value: "pengirim_detil.nama", sortable: false },
        { text: "Penerima", value: "penerima_detil.nama", sortable: false },
        { text: "Actions", value: "actions", sortable: false, align: "center" }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true
    },
    search() {
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;

      await axios
        .get(`ttb`, {
          params: {
            type: "paginate",
            limit: this.options.itemsPerPage,
            page: this.options.page,
            sortBy: this.options.sortBy[0] ? this.options.sortBy[0] : null,
            sortDesc: this.options.sortDesc[0]
              ? this.options.sortDesc[0]
              : null,
            search: this.search
          }
        })
        .then(res => {
          this.data = res.data.data;
          this.totalData = res.data.total;

          this.loading = false;
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    async deleteItem(item) {
      if (!confirm("Apakah anda yakin ingin menghapus data ini?")) return;

      this.loading = true;

      await axios
        .delete(`ttb/${item.kodettb}`)
        .then(res => {
          this.loading = false;

          this.fetchData();
        })
        .catch(err => {
          this.loading = false;
          alert(err.response.data.message);
        });
    }
  }
};
</script>
